import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.css';

const propTypes = {
  content: PropTypes.string,
  displayName: PropTypes.string,
  renderedComponent: PropTypes.object
};

const defaultProps = {
  content: '',
  displayName: '',
  renderedComponent: null
};


function ActivityText({content, displayName, renderedComponent}) {
  if (renderedComponent) {
    return (
      <div className={classNames('ciscospark-activity-text', styles.activityText)}>
        {renderedComponent}
      </div>
    );
  }

  const htmlContent = {__html: content || displayName};

  return (
    <div
      className={classNames('ciscospark-activity-text', styles.activityText)}
      // eslint-disable-reason content is considered safe from server
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={htmlContent}
    />
  );

  /* eslint-enable react/no-danger */
}

ActivityText.propTypes = propTypes;
ActivityText.defaultProps = defaultProps;

export default ActivityText;
